export default __webpack_public_path__ + "static/media/Untitled-1-04.f25b83bf.jpg";